const QUERY = '.site-header';
const CSS = (query) => `
    ${query} {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        will-change: transform;
        -webkit-transform: translateY(-150%);
            -ms-transform: translateY(-150%);
                transform: translateY(-150%);
        -webkit-transition: -webkit-transform 0.4s ease;
            transition: -webkit-transform 0.4s ease;
                -o-transition: transform 0.4s ease;
        transition: transform 0.4s ease, backdrop-filter 0.4s ease;
        transition: transform 0.4s ease, -webkit-transform 0.4s ease, backdrop-filter 0.4s ease;
        z-index: 100;
    }

    ${query}.sticky {
        -webkit-transform: translateY(0);
            -ms-transform: translateY(0);
                transform: translateY(0);
    }

    ${query}.blur .site-header__container {
        -webkit-backdrop-filter: blur(10px);
        backdrop-filter: blur(10px);
        background-color: #1a1a1a26;
    }
`;

/**
 * This feature is used to set header behavior
 * 
 * @class Header
 * @param {string} [query]
 * @param {number} [offset]
 * @param {string} [type]
 */

export default class Header {
    constructor (query = QUERY, offset = 0, type = 'sticky') {
        this.query = query;
        const el = document.querySelector(this.query);
        if (!el) throw new Error('Header not found');
        this.header = el;
        this.type = type;
        this.offset = offset;
        const head = document.head || document.querySelector('head');
        this.head = head || null;
        this.init();
    }

    init () {
        this.setStyles();
        if (this.type === 'sticky') this.sticky();
    }

    setStyles () {
        if (!this.head) return;
        const style = document.createElement('style');
        style.setAttribute('id', 'site-header-css');
        style.type = 'text/css';
        if (style.styleSheet){
            style.styleSheet.cssText = CSS(this.query);
        } else {
            style.appendChild(document.createTextNode(CSS(this.query)));
        }
        this.head.append(style);
    }

    sticky () {
        const gth = this;
        this.header.classList.add('sticky');
        let prev = window.scrollY || window.pageYOffset;
        const THRESHOLD = 5;
        window.addEventListener('scroll', () => {
            const current = window.scrollY || window.pageYOffset;
            if (current > gth.offset) {
                if (current > prev + THRESHOLD) {
                    gth.header.classList.remove('sticky', 'blur');
                } else if (current < prev - THRESHOLD) {
                    gth.header.classList.add('sticky');
                    if (current > 0) gth.header.classList.add('blur');
                }
            } else {
                gth.header.classList.add('sticky');
                gth.header.classList.remove('blur');
            }
            prev = current;
        });
    }
}

/**
 * Usage example
 * 
 * const header = new Header('.header', 50, 'sticky');
 * 
 * or
 * 
 * const header = new Header('.header');
 * 
 */
